import { UserDTO } from "./dtos";
import { UserRole } from "./UserRole";

export class AppUser {
	/**id in db*/
	public userId:number;
	/**id from Firebase auth*/
	public fbUserId:string;
	public displayName:string;
	public role:number = UserRole.USER;
	
	public updateFromUserDTO(dto:UserDTO):void {
		this.userId = dto.userId;
		this.fbUserId = dto.fbUserId;
		this.displayName = dto.displayName;
		this.role = dto.role;
	}
}